var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none",
    viewBox: "0 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 10q0 .564.451 1.027l8.793 8.59q.18.19.406.293.237.09.508.09.372 0 .677-.17.304-.18.474-.473.18-.294.18-.666a1.3 1.3 0 0 0-.405-.948l-8.5-8.296v1.095l8.5-8.285a1.3 1.3 0 0 0 .406-.948q0-.372-.18-.666a1.2 1.2 0 0 0-.475-.462A1.3 1.3 0 0 0 10.158 0q-.53 0-.914.384L.45 8.973A1.372 1.372 0 0 0 0 10"
  })));
};
export default SvgArrowLeft;